export const EVENT_CHANNEL = 'peopleTeams';

export enum AnalyticsEventSource {
	USER_PROFILE_SCREEN = 'userProfileScreen',
	TEAM_PROFILE_ABOUT = 'teamProfileAbout',
	TEAM_PROFILE_SCREEN = 'teamProfileScreen',
}
